import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "ps-0 d-sm-none mb-3" }
const _hoisted_3 = {
  class: "float-end btn-group",
  role: "group"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "ps-0 d-none d-sm-block" }
const _hoisted_8 = { key: 1 }

import { ref, computed, watch } from "vue";
import { getAgeByPlanYear } from "@/guiide/ts/utilities";
import { getCalendarYearText } from "@/guiide/ts/wants/wantsUtilities";
import { formatter } from "@/shared/ts/formatter";
import Dropdown from '../common/Dropdown.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IncomeDescriber',
  props: {
    showDescription: { type: Boolean, default: false },
    planYears: { type: Number, default: 0 },
    initialPlanningYear: { type: Number, default: new Date().getFullYear() },
    retiringOnJanFirst: { type: Boolean, default: false },
    planYear: { type: Number, default: 0 },
    amount: { type: Number, default: 0 },
    editDisabled: { type: Boolean, default: true },
    incrementButtonsVisible: { type: Boolean, default: true }
},
  emits: {
    'yearSelected': null,
    'edit': null,
    'decrement': null,
    'increment': null
},
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

watch(() => props.planYear, (newPlanYear: number) => { selectedPlanYear.value = (newPlanYear + 1).toString() });

watch(() => props.editDisabled, (newEditDisabled: boolean) => {
    editButtonsDisabled.value = newEditDisabled;
});

const selectedPlanYear = ref("1");
const editButtonsDisabled = ref(false);

const planYearOptions = computed<Array<string>>(() => {
    return Array.from({ length: props.planYears }, (_, i) => (i + 1).toString());
});

const selectedPlanYearText = computed<string>(() => {
    if (!props.showDescription) {
        return "";
    }

    const annualIncomeFmtd = formatter.formatCurrency(props.amount);
    const calendarYear = props.initialPlanningYear + props.planYear;
    const calendarYearText = getCalendarYearText(calendarYear, props.retiringOnJanFirst);
    const ageInPlanYear = getAgeByPlanYear(props.planYear);

    return ` - age ${ageInPlanYear} in ${calendarYearText} with an income of ${annualIncomeFmtd}`;
});

function onDecrementClicked() {
    emit('decrement');
}

function onIncrementClicked() {
    emit('increment');
}

function onPlanYearSelected(selectedYear: string) {
    emit('yearSelected', parseInt(selectedYear) - 1);
}

function onEditClicked() {
    emit('edit');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showDescription)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createTextVNode("Year ")),
            _createVNode(Dropdown, {
              modelValue: selectedPlanYear.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((selectedPlanYear).value = $event)),
                onPlanYearSelected
              ],
              items: planYearOptions.value,
              optional: false,
              description: ""
            }, null, 8, ["modelValue", "items"]),
            _createTextVNode(" " + _toDisplayString(selectedPlanYearText.value) + " ", 1),
            _createElementVNode("div", _hoisted_3, [
              (__props.incrementButtonsVisible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-outline-secondary btn-sm border-end-0",
                    onClick: onDecrementClicked,
                    disabled: editButtonsDisabled.value
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "bi bi-dash-lg d-inline" }, null, -1)
                  ]), 8, _hoisted_4))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary btn-sm",
                onClick: onEditClicked,
                disabled: editButtonsDisabled.value
              }, "Edit", 8, _hoisted_5),
              (__props.incrementButtonsVisible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-outline-secondary btn-sm border-start-0",
                    onClick: onIncrementClicked,
                    disabled: editButtonsDisabled.value
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "bi bi-plus-lg d-inline" }, null, -1)
                  ]), 8, _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, "Year " + _toDisplayString(__props.planYear + 1) + " " + _toDisplayString(selectedPlanYearText.value), 1)
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_8, " "))
  ]))
}
}

})